var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPermitTypeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2480_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.25H7.96875V9.375H10.7812C11.0298 9.37467 11.2681 9.27579 11.4438 9.10004C11.6195 8.9243 11.7184 8.68604 11.7188 8.4375V1.875C11.7185 1.62645 11.6196 1.38816 11.4438 1.2124C11.2681 1.03665 11.0298 0.937785 10.7812 0.9375H4.21875C3.97019 0.937748 3.73187 1.0366 3.55611 1.21236C3.38035 1.38812 3.2815 1.62644 3.28125 1.875V8.4375C3.28154 8.68605 3.3804 8.92434 3.55615 9.1001C3.73191 9.27585 3.9702 9.37471 4.21875 9.375H7.03125V11.25H1.875C1.62636 11.25 1.3879 11.3488 1.21209 11.5246C1.03627 11.7004 0.9375 11.9389 0.9375 12.1875V14.0625H1.875V12.1875H7.03125V14.0625H7.96875V12.1875H13.125V14.0625H14.0625V12.1875C14.0625 11.9389 13.9637 11.7004 13.7879 11.5246C13.6121 11.3488 13.3736 11.25 13.125 11.25ZM4.21875 1.875H10.7812L10.7822 8.4375H4.21875V1.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55787 6.98855L5.58495 5.96838C5.58691 5.89761 5.64578 5.84174 5.71656 5.8435C6.144 5.8546 6.57144 5.8657 6.99887 5.8768C7.11702 5.87987 7.11911 5.77505 7.12559 5.52557C7.13207 5.27608 6.50911 5.04962 6.53188 4.17252C6.55466 3.29542 7.21236 3.05444 7.7534 3.06849C8.29444 3.08254 8.87705 3.35573 8.85427 4.23282C8.8315 5.10992 8.20276 5.23314 8.19444 5.55332C8.18613 5.87349 8.18524 5.9076 8.28532 5.9102C8.71091 5.92125 9.13652 5.9323 9.56212 5.94336C9.63292 5.94519 9.68884 6.0041 9.687 6.07489L9.66051 7.09508L5.55787 6.98855Z",
    stroke: "white",
    strokeWidth: 0.618025,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2480_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPermitTypeWhite);
export default __webpack_public_path__ + "static/media/Work Permit Type_White.417d4349b452a41efd8c1b783c7be5aa.svg";
export { ForwardRef as ReactComponent };